import { render } from "./CardRegistroSucursales.vue?vue&type=template&id=4b3ad80a&scoped=true"
import script from "./CardRegistroSucursales.vue?vue&type=script&lang=js"
export * from "./CardRegistroSucursales.vue?vue&type=script&lang=js"

import "./CardRegistroSucursales.vue?vue&type=style&index=0&id=4b3ad80a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3ad80a"]])

export default __exports__